<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Master Item List  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="btn btn-primary mr-1" @click="manageImages">
              <i class="fa fa-file-image-o"></i> Images           
          </b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><span class="pt-2">Item Name</span></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname"  placeholder="Item Name"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group >
              <b-input-group-prepend><span class="p-2">Code</span></b-input-group-prepend>
              <b-form-input v-model="tblData.itemcode"  placeholder="Item Code"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col  lg="4">
            <b-input-group >
                <b-input-group-prepend><span class="p-2">Status</span></b-input-group-prepend>
                <b-form-select v-model="tblData.isactive" :plain="true" :options="activeStatus"></b-form-select>
                <b-input-group-append><b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>                      

        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
            <template v-slot:cell(jasa)="data">
              <span v-if="(data.item.jasa==1)">Service</span>
              <span v-else>Material</span>
            </template>
            <template v-slot:cell(isexpireable)="data">
              <span v-if="(data.item.isexpireable==1)">Expireable</span>
            </template>

            <template v-slot:cell(isactive)="data">
              <span v-if="(data.item.isactive==1)" :class="data.item.isactive==1?'alert-success navbar-link p-1':'alert-danger navbar-link p-1'">Active</span>
              <span v-else :class="'alert-danger navbar-link p-1'">Inactive</span>
            </template>

            <template v-slot:cell(unitprice)="data">
             <span v-if="(data.item.unitprice)">{{uanguser}} {{data.item.unitprice | numFormat}}</span>
            </template>
            <template v-slot:cell(lastprice)="data">
             <!-- <span v-if="(data.item.lastprice)">{{data.item.lastpriceuang}} {{data.item.lastprice | numFormat}}</span> <span v-if="data.item.lastpriceunit"> / {{data.item.lastpriceunit}}</span> -->
              <span v-if="(data.item.lastprice)">{{data.item.lastpriceuang}} {{data.item.lastprice | numFormat}}</span>
            </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="(showList==false)">
      <div slot="header">Master Item - Images 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                <b-form-input v-model="model.itemname" disabled ></b-form-input>
            </b-input-group >
            <b-row>
              <b-col md="6">
                <b-input-group >
                  <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                    <b-form-input v-model="model.partnumber" disabled ></b-form-input>
                </b-input-group >
              </b-col>
              <b-col md="6">                            
                  <b-input-group >
                      <b-input-group-prepend><label> UnitSize</label></b-input-group-prepend>
                      <b-form-input v-model="model.unitsize" disabled></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>
          </b-col>
      </b-row>
        <b-card-group>
          <b-card v-for="(item,index) in itemImg" :key="item.imgKey" img-alt="Image" img-top>
            <my-upload field="gambar" :noCircle="true" 
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="showImgTool"
                :width="300"
                :height="300"
                :url="imgUploadUrl"
                langType="en"
                :params="itemImg[index].imgParams"
                :headers="imgHeaders"
                img-format="png"></my-upload>
            <img :src="itemImg[index].imgDataUrl">
            <div slot="footer">
              <b-button variant="btn btn-primary mr-1" @click="toggleShowImg(index)"> <i class="fa fa-file-image-o"></i> Upload</b-button>
              <b-button variant="btn btn-primary mr-1" @click="deleImage(index)"><i class="fa fa-trash"></i>
              </b-button>
              </div>
          </b-card>
        </b-card-group>      
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
  </div>
</template>

<script>
// import fs from "fs";
import item from "../../apis/bakeryitem";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "partnumber",
            label: "Item Code",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            label: "Unit Size",
            thClass: "text-center",
            tdClass: "text-center"
          },
          // {
          //   key: "invunitom",
          //   thStyle: "width:80px",
          //   label: "Inventory UnitSize",
          //   thClass: "text-center",
          //   tdClass: "text-center"
          // },
          {
            key: "isexpireable",
            thStyle: "width:100px",
            label: "Expireable",
          },
          {
            key: "unitprice",
            tdClass: "text-right",
            label: "Sale Price",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "lastvendor",
            label: "Latest Supplier"
          },
          {
            key: "lastprice",
            tdClass: "text-right",
            label: "Latest Price",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "lastpo",
            label: "Lastest P.O#",
            sortable: true
          },
          {
            key: "itemcategory",
            label: "Item Category",
            sortable: true
          },
          {
            key: "isactive",
            label: "Status",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        headcategory:null
      },
      items:[],
      model:{},
        uanguser: this.$store.state.user.matauang,
      itemImg:[{imgDataUrl:'', imgKey:'0'},{imgDataUrl:'', imgKey:'1'},{imgDataUrl:'', imgKey:'2'},{imgDataUrl:'', imgKey:'3'}],
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      img3:'',
      imgIndex:0,
      showImgTool:false,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' }, { value: '0', text: 'Inactive' },{ value: '1', text: 'Active' }],
        jasaMaterial : [{ value: '', text: '-- ALL --' }, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      headCategories:[], itemCategories:[]
    };
  },
  components :{Loading,myUpload},
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.itemlist) {
            this.tblData[key] = filter.itemlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.itemlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await item.list(this.tblData);
      
      this.items=list;
      this.lkuLoading = false;
      return list;  
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemcode = '';
        this.tblData.itemname =  '';
        this.tblData.headcategory = '';
        this.tblData.itemcategory =  '';
        this.tblData.group = '';
        this.tblData.jasa = '';
        this.tblData.isactive = '';
        this.refresh();
    },    
    add: function(data) {
          const filter = this.$store.state.filter;
          filter.itemlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'bakery.itemfrm'});
    },
    edit: function() {
        if (this.model) {
          const filter = this.$store.state.filter;
          filter.itemlist=this.tblData;
          this.$store.commit("filter", filter);
          router.push({name :'bakery.itemfrm', params: { itemno: this.model.itemno}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await item.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    manageImages: async function() {
        if (this.model) {
          this.showList=false;
          const data = await item.token();
          this.imgHeaders= data.headers;
          this.imgUploadUrl= `${data.baseURL}/bakeryitem/uploadImage`;
          this.imgParams= {itemno:this.model.itemno};
          const imgOnSvr = await item.images(this.model);
          for (let index = 0; index < 4; index++) {
            this.itemImg[index].imgKey=index;
            this.itemImg[index].imgDataUrl=''
            this.itemImg[index].imgParams= {itemno:this.model.itemno,imgKey:index };
            if (index<imgOnSvr.length) {
              this.itemImg[index].imgKey=imgOnSvr[index].imgKey;
              this.itemImg[index].imgDataUrl=imgOnSvr[index].imgBase64;
              this.itemImg[index].imgParams.imgKey=imgOnSvr[index].imgKey;
              // dibawah ini cara lain menampilkan gambar dari server tanpa di konversi ke base64            
              // this.itemImg[index].src=`${data.baseURL}/image/asset/${imgOnSvr[index].imgKey}`;
              // in HTML Template do like this: <img :src="itemImg[index].src">
            }
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    toggleShowImg(index) {
        this.imgIndex=index;
          console.log('this.imgIndex ',this.imgIndex);
          this.showImgTool = !this.showImgTool;
    },
    cropSuccess(imgDataUrl, field){
        console.log('-------- crop success --------', field);
        this.itemImg[this.imgIndex].imgDataUrl = imgDataUrl;
        console.log(imgDataUrl);
        console.log('content ',this[field]);
    },
    cropUploadSuccess(jsonData, field){
        console.log('-------- upload success --------');
        console.log(jsonData);
        console.log('field: ' + field);
    },
    cropUploadFail(status, field){
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await item.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
